module.exports = __webpack_public_path__ + "static/img/2_03.66ca769.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250618/2_03.jpg
// module id = X70m
// module chunks = 0